<template>
  <div class="container">
    <h1 class="text-center">Tag <code>{{ tagName }}</code></h1>
    <hr>
    <br />
    <div class="tag-grid">
      <div
        :key="index"
        v-for="(post, index) in (tag ? tag.posts : [])"
        class="tag-col"
      >
        <PostCard :post="post" />
      </div>
    </div>
  </div>
</template>

<script>
import PostCard from '@/components/PostCard.vue'

export default {
  name: 'ViewTag',
  components: {
    PostCard
  },
  data: function () {
    return {
      tagName: this.$route.params.tag
    }
  },
  computed: {
    tag: function () {
      for (let i = 0; i < this.tags.length; i++) { // match current tag
        if (this.tags[i].name === this.tagName) {
          return this.tags[i]
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
.tag-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
}

.tag-col {
  margin-bottom: 30px;
}
</style>
